import { memo } from 'react'
import { IconButton, useColorScheme } from '@mui/material'
import { m } from 'framer-motion'
import { faBrightness, faMoon } from '@fortawesome/pro-duotone-svg-icons'

import { varTap, varHover, transitionTap } from 'src/components/animate'
import FaIcon from '../../components/shared/faIcon/FaIcon'
import { THEME_MODE } from '../../libs/qb-brand-web-components'

const ThemeSwitchButton = () => {
  const { setMode, mode } = useColorScheme()
  const isDarkMode = mode === THEME_MODE.DARK
  return (
    <IconButton
      component={m.button}
      whileTap={varTap(0.96)}
      whileHover={varHover(1.04)}
      transition={transitionTap()}
      onClick={() => {
        setMode(isDarkMode ? THEME_MODE.LIGHT : THEME_MODE.DARK)
      }}
      sx={{
        p: 0,
        width: 40,
        height: 40
      }}
    >
      <FaIcon icon={!isDarkMode ? faMoon : faBrightness} size='xs' />
    </IconButton>
  )
}

export default memo(ThemeSwitchButton)
